import AdsError from './AdsError.js'

export class MotosNotImplementedError extends AdsError {}
